import { Component, Input } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';

import { SharedService } from 'src/app/core/services/shared.service';
import { AdminFile } from 'src/app/core/interfaces/shared.interface';
import { AdminFileStore, SimpleActionCreator } from 'src/app/shared/helpers/types';
import { FilesService } from 'src/app/core/services/files.service';
import { errors } from 'src/app/shared/helpers/errors';
import { translations } from 'src/i18n/translations';
import * as CompanyActions from '../../../../modules/companies/store/company.actions';

@Component({
  selector: 'app-detail-view-admin-files',
  templateUrl: './detail-view-admin-files.component.html'
})
export class DetailViewAdminFilesComponent {
  adminFileUrl = `${this.sharedService.baseUrl}files/`;
  @Input() action: SimpleActionCreator<any>;
  @Input() contentType: string;
  @Input() deleteAction: SimpleActionCreator<any>;
  @Input() id: string;
  @Input() files: AdminFile[];

  constructor(private filesService: FilesService, private sharedService: SharedService, private store: Store<AdminFileStore>) {}

  deleteAdminFile(id: string): void {
    this.filesService.deleteAdminFile(id).subscribe(() => {
      this.store.dispatch(this.deleteAction({ id }));
      this.filesService.notifyAboutFileStatus(translations[this.sharedService.language].deleted);
    });
  }

  uploadFile(files: FileList, element: HTMLInputElement): void {
    const preparedFile = this.filesService.prepareFile(files, this.contentType, this.id);
    this.filesService.uploadFile(preparedFile).subscribe(
      () => {
        this.store.dispatch(this.action({ id: this.id }));
        element.value = '';
        this.filesService.notifyAboutFileStatus(translations[this.sharedService.language].uploaded);
      },
      (error: HttpErrorResponse) => {
        element.value = '';
        this.sharedService.showError(errors[error.error.file[0]][this.sharedService.language]);
      }
    );
  }
}
